import { render, staticRenderFns } from "./OrderRequestView.vue?vue&type=template&id=6920f06a&scoped=true"
import script from "./OrderRequestView.vue?vue&type=script&lang=js"
export * from "./OrderRequestView.vue?vue&type=script&lang=js"
import style0 from "./OrderRequestView.vue?vue&type=style&index=0&id=6920f06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6920f06a",
  null
  
)

export default component.exports